import { useLayoutEffect } from 'react';
import { track, stopTrack } from '@americanexpress/aqx-components';

/**
  Docs: https://shopcomponents-dev.aexp.com/packages-utilities-src-with-event-tracking-index
  Usage Example: page_modules/business-pdp/index.js 
**/

export default ({ trackingFn, analyticsData }) => {
  useLayoutEffect(
    () => {
      const trackingFnInstance = trackingFn(analyticsData);
      track(trackingFnInstance);

      return () => {
        stopTrack(trackingFnInstance);
      };
    },
    [analyticsData]
  );

  return null;
};
